<template>
      <div id="home-content">
            <section id="home-hero" class="section">
                  <div class="grid-container">
                        <div class="grid-x grid-padding-x">
                              <div class="cell medium-12 large-5">
                                    <h1 class="mt32"><span>Blue High Performance Network<sup>SM</sup> (BlueHPN<sup>SM</sup>) could be right for you</span></h1>
                                    <p class="content">{{content}}</p>
                                    <p class="video-btn video-cta">
                                          <a @click="openVideo()"><img src="img/anthem-play-icon.png" width="36"/> <span>Watch our video</span></a>
                                    </p>
                                    <div class="grid-x grid-padding-x">
                                          <div class="cell small-6">
                                                <router-link to="/evaluation" class="button warning anthem-btn expanded">Start Evaluation Quiz</router-link>
                                          </div>
                                          <div class="cell small-6">
                                                <a href="#main-content" @click="track('Learn More')" class="button hollow mb0 expanded" target="_blank" v-smooth-scroll>Learn More</a>
                                          </div>
                                    </div>
                              </div>
                              <div class="cell large-6 large-offset-1 video-img-cta">
                                    <div style="position: relative; display: block; max-width: 960px;">
                                          <div style="padding-top: 56.25%;">
                                                <iframe src="https://player.vimeo.com/video/455985379?autoplay=0" allow="encrypted-media" style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;"  frameborder="0" allowfullscreen></iframe>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <section id="main-content" class="section">
                  <div class="main-content-features">
                        <div class="grid-container">
                              <div class="grid-x grid-padding-x">
                                    <div class="cell large-12 text-center">
                                          <h2 class="text-center">A plan that works for you</h2>
                                    </div>
                              </div>
                              <div class="grid-x grid-padding-x mb48">
                                    <div class="cell large-4">
                                          <img src="img/save-time.jpg" width="300"/>
                                    </div>
                                    <div class="cell large-7">
                                          <h3>Great Care</h3> 
                                          <p>Doctors are included in the network based on their efficiency and effectiveness. BlueHPN gives you access to doctors and hospitals in 58 markets (and growing) across the country. In areas where the BlueHPN is not offered, coverage is limited to urgent and emergency care only.</p>
                                    </div>
                              </div>
                              <div class="grid-x grid-padding-x mb48">
                                    <div class="cell large-4">
                                          <img src="img/new-technology.jpg" width="300"/>
                                    </div>
                                    <div class="cell large-7">
                                          <h3>Smart Savings</h3>
                                          <p>Blue HPN is committed to saving you money. This starts with finding doctors committed to fair pricing. You will also have access to the Cost Estimator to avoid unexpected medical bills. </p>
                                    </div>
                              </div>
                              <div class="grid-x grid-padding-x">
                                    <div class="cell large-4">
                                          <img src="img/check-status.jpg" width="300"/>
                                    </div>
                                    <div class="cell large-7">
                                          <h3>An easy experience</h3>
                                          <p>We are here to help you make the most of your plan by offering budget-friendly and flexible choices. Our high quality network offers intuitive digital tools to simplify your health care experience. </p>
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <section id="footer" class="section">
                  <div class="grid-container">
                        <div class="grid-x grid-padding-x align-center">
                              <div class="cell large-7">
                                    <h2 class="text-center"><img src="img/anthem-quiz-icon.png" width="60"/>  Evaluation Quiz</h2>
                                    <p class="text-center">See if BlueHPN is a good option for you<br class="show-for-medium"/> by taking our short quiz.</p>
                                    <div class="grid-x grid-padding-x align-center">
                                          <div class="cell small-5 large-5">
                                                <router-link to="/evaluation" class="button warning anthem-btn expanded">Start Evaluation Quiz</router-link>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <section id="footer-copy" class="section">
                  <div class="grid-container">
                        <div class="grid-x gird-padding-x">
                              <div class="cell large-12">
                                    <p>1034850MUMENMUB BV 07/21</p>
                                    <p>&copy; 2022-2024 Anthem. Anthem Blue Cross is the trade name of Anthem HealthChoice HMO, Inc. and Anthem HealthChoice Assurance, Inc. Anthem Blue Cross HP is the trade name of Anthem HP, LLC. Independent licensees of the Blue Cross and Blue Shield Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.</p> 
                              </div>
                        </div>
                  </div>
            </section>
      </div>
</template>

<script>
      export default {
            name: "AnthemLinkHome",
            data(){
                  return{
                        sloganIn: 'BlueHPN',
                        title: "BlueHPN could<br class='break'/> be right for you",
                        content: "You know what matters most to you for your health. That is why we offer top-tier health care and a personalized member experience. BlueHPN could be a great choice for you and your family’s needs."
                  }
            },
            methods: {
                  openVideo(){
                        let message = '<div style="position: relative; display: block; max-width: 960px;"><div style="padding-top: 56.25%;"><iframe src="https://player.vimeo.com/video/455985379?autoplay=0" allow="encrypted-media" style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;"  frameborder="0" allowfullscreen></iframe></div></div>'
                        this.$fire({
                              html: message,
                              showConfirmButton: false,
                              showCancelButton: false,  
                              showCloseButton: true,
                              width:'58em'
                        })
                        this.track('Watch Our Video')
                  },
                  track(label) {
                        this.$gtag.event('Click', {
                              'event_category': 'CTA',
                              'event_label': label,
                              'value': 1
                        })
                  }
            }
      }
</script>

<style lang="scss">
      .swal2-close{
            top:-14px !important;
            right:-14px !important;
            font-size: 1.5rem !important;
            color: #ffffff !important;
            background: #1779ba !important;
            line-height: 1.08 !important;
            border-radius: 50% !important;
            transition: all 0.2s ease-in-out 0s !important;
      }
      .swal2-close:hover{
            background: #1468a0 !important;
      }
      
      .font-disclaimer{
            font-size: 0.75rem !important;
      }
      .font-orange{
            font-size: 1.25rem !important;
            color: #f38021 !important;
            font-weight: 600;
      }
      .video-cta{
            display: none !important;
      }
      #home-content{
            position: relative;
            .section{
                  padding:120px 0px;
            }
            h1{
                  color:#0079c2;
                  font-weight: 600;
                  font-size: 3.25rem !important;
                  line-height: 3.25rem;
                  margin-bottom: 1.5rem !important;
                  span{
                        color:#012169;
                  }
            }
            p{
                  margin-bottom:1.125rem !important; 
                  font-size: 1.125rem;
            }
            .subtitle{
                  font-size: 1.45rem;
                  font-weight: 600;
            }
            .content{
                  margin-bottom: 3rem !important;
                  color:#012169;
                  font-weight: 400;
                  line-height: 1.6;
            }
            
            /*.anthem-btn {
                  color: #ffffff;
                  background-color: #0079c2 !important;
                  &:hover{
                        background-color: #126195 !important;
                  }
            }*/
            #home-hero{
                  padding-bottom: 60px;
                  /*position: relative;
                  background-size: 768px;
                  background-image: url("/img/family-anthem.png");
                  background-repeat: no-repeat;
                  background-position: right 39%;
                  .content-block{
                        position: absolute;
                        max-width: 560px;
                        top: 45%;
                        left: 15%;
                        transform: translateY(-50%);
                  }*/
                  .video-btn{
                        color:#0079c2; 
                        font-size: 1.5rem; 
                        font-weight: 600;
                        display: block;
                        position: relative;
                        /*&:before{
                              content:"";
                              position: absolute;
                              left: 50%;
                              top:50%;
                              border: 0;
                              background: transparent;
                              box-sizing: border-box;
                              border-color: transparent transparent transparent rgba(255,255,255,0.5);
                              transition: all 0.2s ease-in-out 0s;
                              cursor: pointer;
                              border-style: solid;
                              border-width: 27px 0 27px 45px;
                              z-index: 1;
                              transform: translate(-50%, -50%);
                        }
                        &:hover{
                              &:before{
                                    border-color: transparent transparent transparent rgba(255,255,255,0.8);
                              }
                        }*/
                  }
                  
            }
            #main-content{
                  position: relative;
                  padding-top:60px;
                  padding-bottom: 0px;
                  /*&:before{
                        content:"";
                        background-color: transparent;
                        position: absolute;
                        border-top: solid 4px #f38021;
                        border-right: solid 4px #f38021;
                        top: -20px;
                        left: 0;
                        bottom: 0px;
                        width: 92%;
                        z-index: 1;
                        border-radius: 0px 40px 0px 0px;
                        transform: skewY(2deg);
                  }*/
                  .grid-container{
                        max-width:90rem;
                  }
                  h2,h3{
                        color:#0079c2;
                  }
                  h2{
                        font-size: 3rem !important;
                        margin-bottom: 6rem !important;
                        position: relative;
                        z-index: 2;
                        font-weight: 600;
                  }
                  h3{
                        font-size: 2rem !important;
                        margin-bottom: 1rem !important;
                  }
                  .main-content-features{
                        position: relative;
                        .grid-container{
                              background-color: #fefefe;
                              position: relative;
                              padding-top: 4rem;
                              padding-bottom: 5rem;
                              .cell{
                                    position: relative;
                                    z-index: 2;
                              }
                              /*&:before{
                                    content:"";
                                    background-color: #cde9f8;
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    bottom: 0;
                                    width: 83%;
                                    z-index: 0;
                                    border-radius: 72px 0px 0px 0px;
                              }*/
                        }
                        img{
                              position: relative;
                        }
                        /*&:before{
                              content:"";
                              background-color: #cde9f8;
                              position: absolute;
                              top: 0;
                              right: 0;
                              bottom: 0;
                              width: 50%;
                              z-index: 0;
                        }*/
                  }
                  
            }
            #footer{
                  background-color: #58b6e7;
                  position: relative;
                  z-index: 2;
                  .grid-container{
                        max-width:90rem;
                  }
                  &.section{
                        min-height: 400px; 
                        padding:60px 0px;
                  }
                  h2, p{
                        color:#ffffff;
                  }
                  h2{
                        font-size: 2.5rem !important;
                        font-weight: 600;
                        margin-bottom: 1.5rem !important;
                  }
                  p{
                        margin-bottom: 1.5rem !important;
                        font-weight: 600;
                  }
            }
            #footer-copy{
                  .grid-container{
                        max-width:90rem;
                  }
                  &.section{
                        min-height: 300px; 
                        padding:60px 0px;
                  }
                  p{
                        font-size: 0.75rem !important;
                        margin-bottom: 0px !important;
                        color:#666666;
                        &:first-child{
                              margin-bottom:1.125rem !important;
                        }
                  }
            }
            
      }
      
      @media only screen and (max-width:1542px){
            #home-content #home-hero .content-block{
                  left:3%;
            }
      }
      @media only screen and (max-width:1452px){
            
            #home-content #home-hero .content-block{
                  p.content{
                        font-size: 1.125rem;
                  }
            }
            #home-content .content{
                  margin-bottom: 2rem!important;
            }
            
            #main-content{
                  padding-top:20px !important;
            }
      }
      @media only screen and (max-width:1280px){
            .break{
                  display: none;
            }
            .video-btn{
                  margin:  0 auto;
                  /*span{
                        color: #ffffff;
                  }*/
            }
            #home-content #home-hero .content-block h1{
                  color: #ffffff;
                  font-size: 2rem !important;
                  line-height: 2.5rem !important;
                  text-align: center;
            }
            #home-content #home-hero .content-block p{
                  color: #ffffff;
            }
            #home-content #main-content:before{
                  display: none;
            }
            
      }
      @media only screen and (max-width:1023px){
            #home-hero{
                  padding-top:30px !important;
                  text-align: center;
            }
            #home-content h1{
                  font-size: 2.5rem !important;
            }
            .align-btn-center{
                  justify-content: center;
            }
            ul{
                  margin: 0 auto !important;
                  max-width: 450px !important;
                  text-align: left !important;
                  li{
                        margin-bottom: 16px;
                  }
            }
            .video-cta{
                  display: block !important;
            }
             .video-img-cta{
                  display: none;
            }
            .break{
                  display: none;
            }
            #home-content #main-content{
                  padding-top: 2rem !important;
            }
            #home-content #main-content h2 {
                  margin-bottom: 2rem !important;
            }
            #home-content #main-content .main-content-features .grid-container:before{
                  width:100%;
                  border-radius: 0px;
            }
            #home-content #main-content .main-content-features .grid-container .cell{
                  text-align: center;
            }
            #home-content #main-content .main-content-features img{
                  margin-bottom: 40px !important;
            }
            .swal2-popup{
                  background:none !important;
            }
            .swal2-close{
                  right:-8px !important;
            }
      }
      @media only screen and (max-width:640px){
            ul{
                  max-width: 350px !important;
            }
            #header .button.anthem-btn{
                  font-size: 0.87rem !important;
            }
            #home-content #home-hero {
                  min-height: 300px;
            }
             #home-content #home-hero .content-block p.content{
                 display: none;
            }
            #home-content .content-block .button.anthem-btn, 
            #home-content .content-block .button.hollow,
            #footer .button.anthem-btn{
                  font-size: 0.87rem !important;
            }
            #home-content #main-content h2 {
                  font-size: 2rem !important;
                  line-height: 2.5rem !important;
                  margin-bottom: 2rem !important;
            }
            #main-content{
                  padding-top:70px !important;
            }
            #home-content #footer.section{
                  min-height: 300px !important;
            }
            #home-content #footer h2 {
                  font-size: 2.2rem !important;
                  img{
                        width:15% !important;
                  }
            }
            #home-content #footer p {
                  margin-bottom: 1rem !important;
            }
      }
      @media only screen and (max-width:420px){
            #header .button.anthem-btn{
                  font-size: 0.83rem !important;
            }
      }
</style>
